import Model from "./base/model";

class QuoteStatus extends Model{
  resourceName() {
    return "quote_status";
  }

  fields() {
    return {
      name: "",
      description: ""
    };
  }
}

export default new QuoteStatus();
